import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';

import { TellentAppShellTopbarButtonComponent } from '@core/tellent-smart-ui';
import { TellentWebComponent } from '@core/tellent-types';
import { IconName } from '@core/user-interface-legacy';

@Component({
  selector: 'x-app-shell-topbar-button',
  template: `
    <tlc-app-shell-topbar-button
      [iconName]="iconName()"
      [label]="label()"
      [iconNameActive]="iconNameActive()"
      [isActive]="isActive()"
    />
  `,
  styles: `
    :host {
      display: contents;
    }
  `,
  imports: [TellentAppShellTopbarButtonComponent],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TellentAppShellTopbarButtonWrapComponent {
  public iconName = input.required<IconName>();
  public label = input<string>();
  public iconNameActive = input<IconName>();
  public isActive = input<boolean>(false);
}

export type TellentAppShellTopbarButtonWebComponent = TellentWebComponent<
  TellentAppShellTopbarButtonWrapComponent,
  'iconName' | 'label' | 'iconNameActive' | 'isActive'
>;
